import { useEffect } from "react";
import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import SectionHeading from "@/components/feature/SectionHeading";
import MovieGrid from "@/components/feature/MovieGrid";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import IntroSection from "@/pages/home/components/IntroSection";
import { movies } from "@/mocks/movies";
import { useFavorites } from "@/hooks/useFavorites";

export default function Home() {
  const { isFavorite, toggle } = useFavorites();

  useEffect(() => {
    document.title = "日韩中文字幕在线观看－海量日韩影视剧在线播放";
  }, []);

  const featured = movies.filter((movie) => movie.featured);
  const latest = [...movies]
    .sort((a, b) => b.year - a.year || b.popularity - a.popularity)
    .slice(0, 12);
  const popular = [...movies]
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, 8);
  const counts = {
    drama: movies.filter((movie) => movie.type === "电视剧").length,
    movie: movies.filter((movie) => movie.type === "电影").length,
  };

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1">
        <HeroCarousel items={featured} />

        <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
          <section className="pt-12 md:pt-16">
            <SectionHeading
              title="分类快捷入口"
              subtitle="按影视类型快速进入，支持多维度筛选"
            />
            <CategoryEntry counts={counts} />
          </section>

          <section className="pt-14 md:pt-20">
            <SectionHeading
              title="最新上线"
              subtitle="按年份排序，最近收录的日韩影视"
              moreTo="/category/drama"
              moreLabel="浏览电视剧"
            />
            <MovieGrid
              movies={latest}
              isFavorite={isFavorite}
              onToggleFavorite={toggle}
            />
          </section>

          <section className="pt-14 md:pt-20">
            <SectionHeading
              title="热门推荐"
              subtitle="近期最受中文观众欢迎的日韩影视"
              moreTo="/category/movie"
              moreLabel="浏览电影"
            />
            <MovieGrid
              movies={popular}
              isFavorite={isFavorite}
              onToggleFavorite={toggle}
            />
          </section>

          <section className="py-14 md:py-20">
            <IntroSection />
          </section>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}